import React from "react";
import { Select } from 'antd';

export default class SelectComponentEmpty extends React.Component {

  constructor(props) {
    super(props);
    this.state = { data: props.data, selected: props.selected, inActive: props.inActive, id: props.id };
  }

  onChange = (e) => {
    this.props.onChange(e)
  }

  render() {

    let selected = null;
    let inActive = this.state.inActive;

    return (
      <>
        <Select
          showSearch
          allowClear
          defaultValue={selected}
          id={this.state.id}
          className="select-consulta"
          style={{ width: '100%' }}
          placeholder="-- Seleccionar --"
          optionFilterProp="children"
          onChange={this.onChange}
          disabled={inActive}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }>
        </Select>
      </>
    );
  }
}